export enum EUserRole {
  None = 0,
  Administrator = 1,
  Support = 2,
  Regular = 3,
}

export interface User {
  isActive: boolean;
  userName: string;
  password: string;
  userEmail: string;
  name: string;
  surname: string;
  dateCreated: string;
  userRole: EUserRole;
  userOtp?: string;
  otpExpiredAt?: string,
}

export interface UserCredential {
  token: string;
  role: number;
  userName: string;
  userEmail: string;
}

export interface UserTokenResult {
  role: string;
  unique_name: string;
  email: string;
  nbf: number;
  exp: number;
  iat: number;
}

export interface UserRequestOtp {
  userName: string;
}

export interface UserResetPassword {
  userOtp: string;
  newPassword: string;
}

export interface UserLogin {
  userName: string;
  password: string;
}

export interface AuthenticationEnable {
  enable: boolean;
}